import React, { useEffect, useState } from 'react';
import { Button, Form, FormControl, InputGroup, Nav } from 'react-bootstrap';
import { FaFileAlt, FaRegFrownOpen } from 'react-icons/fa';
import { MdClose } from 'react-icons/md';
import CustomModal from '../../../components/CustomModal';
import NothingToShow from '../../../components/NothingToShow';
import PageContainer from '../../../components/PageContainer';
import { menuRelatorios, applyFiltroMenu } from './RelatoriosMainPageInfo';
import './RelatoriosMainPage.css';
import { useHistory, useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min';
import ProjetosApiService from '../../../services/api/ProjetosApiService';
import Loading from '../../../components/Loading';
import useAlertNotification from '../../../context/AlertNotificationContext';
import FiltroHistoricoCusto from './CustomModalRelatorios/FiltroHistoricoCusto';
import FiltroRelatorioCapacidade from './CustomModalRelatorios/FiltroRelatorioCapacidade';
import FiltroRelatorioComparativo from './CustomModalRelatorios/FiltroRelatorioComparativo';
import CadastroClientesService from '../../../services/api/CadastroClientesService'
import { RelatorioListHelpModal } from './RelatorioListHelpModal';
import { FiInfo } from "react-icons/fi";
import FiltroCapacidadePorProjeto from './CustomModalRelatorios/FiltroCapacidadePorProjeto';
import FiltroFluxoDeCaixa from './CustomModalRelatorios/FiltroFluxoDeCaixa';
import ModalFiltros from './CustomModalRelatorios/Component/ModalFiltros';
import FormatDataService from '../../../services/util/FormatData';
import FiltroResultadosDoCliente from './CustomModalRelatorios/FiltroResultadosDoCliente';

function RelatoriosMainPage(props) {

    //Uses
    const history = useHistory();
    const match = useRouteMatch();
    const alert = useAlertNotification();

    //States
    const [filtro, setFiltro] = useState("");
    const [filtrado, setFiltrado] = useState(menuRelatorios);
    const [dataProjects, setDataProjects] = useState([]);
    const [clientes, setClientes] = useState([]);
    const [activePopup, setActivePopup] = useState(null);
    const [lideres, setLideres] = useState([]);

    //Chamadas de requisição
    const getProjectsData = async () => {
        try {
            const data = await ProjetosApiService.getAllProject();
            setDataProjects(data.data.data);

            const uniqueLeads = data.data.data.reduce((accumulator, current) => {
                if (!accumulator.some(item => item.lead === current.lead)) {
                    accumulator.push(current);
                }
                return accumulator;
            }, []);
            setLideres(uniqueLeads)

        } catch (error) {
            console.error('Erro ao obter os projetos:', error);
        }
    }

    const getClientsList = async () => {
        try {
            const data = await CadastroClientesService.getAllClients();
            setClientes(data.data)
        } catch (error) {
            console.error('Erro ao chamar todos os clientes:', error);
        }
    }

    //Funções de passagem de dados para as páginas dos relatórios
    const clearFiltro = () => setFiltro("");

    const handleFiltro = () => {
        const menuFiltrado = applyFiltroMenu(filtro);
        setFiltrado(menuFiltrado);
    }

    const handleDadosRelatorioCapacidade = (periodoInicial, periodoFinal, projetos) => {
        if (periodoFinal < periodoInicial) {
            alert.error("Período Inicial menor que Período Final.");
        } else {
            const dataInicialFormatada = new Date(periodoInicial.getFullYear(), periodoInicial.getMonth(), "01").toLocaleDateString('pt-BR');

            const ultimoDia = new Date(periodoFinal.getFullYear(), periodoFinal.getMonth() + 1, 0).getDate();
            const dataFinalFormatada = new Date(periodoFinal.getFullYear(), periodoFinal.getMonth(), ultimoDia).toLocaleDateString('pt-BR');

            const dados = {
                "projetos": projetos,
                "periodoInicial": dataInicialFormatada,
                "periodoFinal": dataFinalFormatada,
            }
            history.push({
                pathname: 'relatorio-capacidade-area',
                state: { data: dados }
            });
        }
    }

    const handleDadosFluxoCaixa = (projetosSelecionados, radioValue, periodoInicial, periodoFinal, clienteSelecionado, liderSelecionado) => {

        if (projetosSelecionados.length == 0 || !radioValue || !periodoInicial || !periodoFinal) {
            alert.error("Preencha todos os campos* antes de prosseguir.");
        } else if (periodoFinal < periodoInicial) {
            alert.error("Período Inicial menor que Período Final.");
        } else {
            const dataInicialFormatada = new Date(periodoInicial.getFullYear(), periodoInicial.getMonth(), "01").toLocaleDateString('pt-BR');

            const ultimoDia = new Date(periodoFinal.getFullYear(), periodoFinal.getMonth() + 1, 0).getDate();
            const dataFinalFormatada = new Date(periodoFinal.getFullYear(), periodoFinal.getMonth(), ultimoDia).toLocaleDateString('pt-BR');
            let filtered = projetosSelecionados;
            projetosSelecionados.some((item) => {
                if (item.value == "TODOS") {
                    filtered = dataProjects.map((proj) => {
                        return {
                            id: proj.id,
                            value: proj.key,
                            label: `${proj.key} - ${proj.name}`,
                            name: proj.name,
                            categoria: proj.category,
                        }
                    })
                }
                if (item.value == "NAO-INT-1000") {
                    filtered = dataProjects.filter((proj) => !proj.name.includes("INT-1000")).map((proj) => {
                        return {
                            id: proj.id,
                            value: proj.key ? proj.key : proj.id,
                            label: `${proj.key} - ${proj.name}`,
                            name: proj.name,
                            categoria: proj.category
                        }
                    })
                }
                return item.value == "TODOS" || item.value == "NAO-INT-1000"
            })
            const dados = {
                "projetosSelecionados": filtered,
                "radioValue": radioValue,
                "periodoInicial": dataInicialFormatada,
                "periodoFinal": dataFinalFormatada,
                "cliente": clienteSelecionado,
                "lider": liderSelecionado
            }
            history.push({
                pathname: 'relatorio-fluxo-caixa',
                state: { data: dados }
            });
        }
    }

    const handleDadosComparativoCustoPlanejamento = (projetoSelecionado, periodoInicial, periodoFinal, radioPeriodo) => {
        if (projetoSelecionado !== "" && projetoSelecionado !== "default" && radioPeriodo !== "default") {
            if (radioPeriodo === "data") {
                history.push(`comparativo-custo/${projetoSelecionado.value}/${projetoSelecionado.id}/
                    ${periodoInicial}/${periodoFinal}`.replace(/\s+/g, ''));
            } else {
                history.push(`comparativo-custo/${projetoSelecionado.value}/${projetoSelecionado.id}/all/all`);
            }
        } else {
            alert.error("Preencha todos os campos antes de prosseguir.")
        }
    };

    const handleDadosComparativoFaturamento = (projetoSelecionado, periodoInicial, periodoFinal, radioPeriodo) => {
        if (projetoSelecionado !== "" && projetoSelecionado !== "default" && radioPeriodo !== "default") {
            if (radioPeriodo === "data") {
                history.push(`comparativo-faturamento/${projetoSelecionado.value}/${projetoSelecionado.id}/
                    ${periodoInicial}/${periodoFinal}`.replace(/\s+/g, ''));
            } else {
                history.push(`comparativo-faturamento/${projetoSelecionado.value}/${projetoSelecionado.id}/all/all`);
            }
        } else {
            alert.error("Preencha todos os campos antes de prosseguir.")
        }
    };

    const handleDadosHistoricoCustoClinte = (projetosSelecionados, radioValue, periodoInicial, periodoFinal, tipoCusto, clienteSelecionado, liderSelecionado) => {
        if (projetosSelecionados.length === 0 || !radioValue || !periodoInicial || !periodoFinal || !tipoCusto) {
            alert.error("Preencha todos os campos* antes de prosseguir.");
        } else if (periodoFinal < periodoInicial) {
            alert.error("Período Inicial menor que Período Final.");
        } else {
            const dataInicialFormatada = new Date(periodoInicial.getFullYear(), periodoInicial.getMonth(), "01").toLocaleDateString('pt-BR');

            const ultimoDia = new Date(periodoFinal.getFullYear(), periodoFinal.getMonth() + 1, 0).getDate();
            const dataFinalFormatada = new Date(periodoFinal.getFullYear(), periodoFinal.getMonth(), ultimoDia).toLocaleDateString('pt-BR');
            const dados = {
                "projetosSelecionados": projetosSelecionados,
                "radioValue": radioValue,
                "periodoInicial": dataInicialFormatada,
                "periodoFinal": dataFinalFormatada,
                "tipoCusto": tipoCusto,
                "cliente": clienteSelecionado,
                "lider": liderSelecionado
            }
            history.push({
                pathname: 'historico-custos',
                state: { data: dados }
            });
        }
    }

    const handleDadosResultadoProjeto = (projetoSelecionado, radioPeriodo, dataInicial, dataFinal) => {
        if (projetoSelecionado !== "" && projetoSelecionado !== "default" && radioPeriodo !== "default" && dataInicial && dataFinal) {
            history.push({
                pathname: `resultado-projeto/${projetoSelecionado.value}/${projetoSelecionado.id}/${radioPeriodo}`,
                state: { data: { projetoSelecionado, dataInicial, dataFinal } }
            })
        } else {
            alert.error("Preencha todos os campos antes de prosseguir.")
        }
    };

    const handleDadosCapacidadePorProjeto = (projetosSelecionados, radioValue, periodoInicial, periodoFinal) => {
        if (projetosSelecionados.length == 0 || projetosSelecionados === "default" || !radioValue || !periodoInicial || !periodoFinal) {
            alert.error("Preencha todos os campos* antes de prosseguir.");
        } else if (periodoFinal < periodoInicial) {
            alert.error("Período Inicial menor que Período Final.");
        } else {
            const dataInicialFormatada = new Date(periodoInicial.getFullYear(), periodoInicial.getMonth(), "01").toLocaleDateString('pt-BR');
            const ultimoDia = new Date(periodoFinal.getFullYear(), periodoFinal.getMonth() + 1, 0).getDate();
            const dataFinalFormatada = new Date(periodoFinal.getFullYear(), periodoFinal.getMonth(), ultimoDia).toLocaleDateString('pt-BR');
    
            const dados = {
                "projetosSelecionados": projetosSelecionados,
                "periodoInicial": dataInicialFormatada,
                "periodoFinal": dataFinalFormatada,
            }
            history.push({
                pathname: 'relatorio-capacidade-projeto',
                state: { data: dados }
            });
        }
    }

    const handleDadosResultadosDoCliente = (anoSelecionado, dataInicial, dataFinal, clienteSelecionado, radioPeriodo, clienteSelecionadoNome, radioFiltrarPor, liderSelecionado, liderSelecionadoNome) => {
        // Validações
        if (radioPeriodo === "" || !radioPeriodo) {
            alert.error("Preencha todos os campos* antes de prosseguir.");
            return;
        }
        
        if (radioFiltrarPor === "" || !radioFiltrarPor) {
            alert.error("Selecione se deseja filtrar por Cliente ou Líder.");
            return;
        }

        if (dataFinal < dataInicial) {
            alert.error("Data Final menor que Data Inicial.");
            return;
        }

        // Validação específica por tipo de filtro
        if (radioFiltrarPor === "cliente") {
            if (clienteSelecionado === "default" || clienteSelecionado === "" || clienteSelecionado === "--Selecione o cliente--") {
                alert.error("Selecione um cliente antes de prosseguir.");
                return;
            }
            
            // Navegação para cliente
            if (anoSelecionado === "total") {
                history.push({
                    pathname: `relatorio-resultados/${clienteSelecionadoNome}`,
                    state: { data: { anoSelecionado, clienteSelecionado } }
                });
            } else {
                history.push({
                    pathname: `relatorio-resultados/${clienteSelecionadoNome}`,
                    state: { data: { dataInicial, dataFinal, clienteSelecionado } }
                });
            }
        } else if (radioFiltrarPor === "lider") {
            if (liderSelecionado === "default" || liderSelecionado === "" || liderSelecionado === "--Selecione o líder--") {
                alert.error("Selecione um líder antes de prosseguir.");
                return;
            }
            
            // Navegação para líder (mesma página, passa líder no lugar do cliente)
            if (anoSelecionado === "total") {
                history.push({
                    pathname: `relatorio-resultados/${liderSelecionadoNome}`,
                    state: { data: { anoSelecionado, liderSelecionado: liderSelecionado } }
                });
            } else {
                history.push({
                    pathname: `relatorio-resultados/${liderSelecionadoNome}`,
                    state: { data: { dataInicial, dataFinal, liderSelecionado: liderSelecionado } }
                });
            }
        }
    }

    const handleDadosRelatorioTurnover = (periodoInicial, periodoFinal) => {
        if (periodoFinal < periodoInicial) {
            alert.error("Período Inicial menor que Período Final.");
        } else {
            history.push({
                pathname: 'relatorio-turnover',
                state: { data: { periodoInicial, periodoFinal } }
            });
        }
    }

    const handleDadosRelatorioHistoricoCapacidade = (periodoInicial, periodoFinal) => {
        if (periodoFinal < periodoInicial) {
            alert.error("Período Inicial menor que Período Final.");
        } else {
            history.push({
                pathname: 'relatorio-historico-capacidade',
                state: { data: { periodoInicial, periodoFinal } }
            });
        }
    }

    const handleDadosRelatorioPontoJira = (periodoInicial, periodoFinal) => {

        // Converte as datas para ignorar as horas e comparar apenas o dia
        const dataInicial = new Date(periodoInicial);
        const dataFinal = new Date(periodoFinal);

        dataInicial.setHours(0, 0, 0, 0);
        dataFinal.setHours(0, 0, 0, 0);

        if (dataFinal < dataInicial) {
            alert.error("Período Inicial menor que Período Final.");
        } else {
            // Verifica se o intervalo entre as datas é maior que 60 dias
            const diffTime = Math.abs(dataFinal - dataInicial);
            const diffDays = diffTime / (1000 * 60 * 60 * 24);

            if (diffDays > 60) {
                alert.error("O período selecionado não pode ultrapassar 60 dias.");
                return;
            }

            history.push({
                pathname: 'comparativo-ponto-jira',
                state: { data: { periodoInicial, periodoFinal } }
            });
        }
    }

    const handleDadosRelatorioHorasExtras = (periodoInicial, periodoFinal) => {

        // Converte as datas para ignorar as horas e comparar apenas o dia
        const dataInicial = new Date(periodoInicial);
        const dataFinal = new Date(periodoFinal);

        dataInicial.setHours(0, 0, 0, 0);
        dataFinal.setHours(0, 0, 0, 0);

        if (dataFinal < dataInicial) {
            alert.error("Período Inicial menor que Período Final.");
        } else {
            // Verifica se o intervalo entre as datas é maior que 60 dias
            const diffTime = Math.abs(dataFinal - dataInicial);
            const diffDays = diffTime / (1000 * 60 * 60 * 24);

            if (diffDays > 60) {
                alert.error("O período selecionado não pode ultrapassar 60 dias.");
                return;
            }

            history.push({
                pathname: 'comparativo-horas-extras',
                state: { data: { periodoInicial, periodoFinal } }
            });
        }
    }

    const handleDadosRelatorioRelacaoHoras = (periodoInicial, periodoFinal) => {

        // Converte as datas para ignorar as horas e comparar apenas o dia
        const dataInicial = new Date(periodoInicial);
        const dataFinal = new Date(periodoFinal);

        dataInicial.setHours(0, 0, 0, 0);
        dataFinal.setHours(0, 0, 0, 0);

        if (dataFinal < dataInicial) {
            alert.error("Período Inicial menor que Período Final.");
        } else {
            // Verifica se o intervalo entre as datas é maior que 30 dias
            const diffTime = Math.abs(dataFinal - dataInicial);
            const diffDays = diffTime / (1000 * 60 * 60 * 24); 

            if (diffDays > 30) {
                alert.error("O período selecionado não pode ultrapassar 30 dias.");
                return;
            }

            history.push({
                pathname: 'comparativo-relacao-horas',
                state: { data: { periodoInicial, periodoFinal } }
            });
        }
    }

    const handleDadosRelatorioHistoricoHorasExtras = (periodoInicial, periodoFinal) => {
        if (periodoFinal < periodoInicial) {
            alert.error("Período Inicial menor que Período Final.");
        } else {
            history.push({
                pathname: 'relatorio-historico-horas-extras',
                state: { data: { periodoInicial, periodoFinal } }
            });
        }
    }

    const handleDadosRelatorioBancoDeHoras = (periodoInicial, periodoFinal) => {
        if (periodoFinal < periodoInicial) {
            alert.error("Período Inicial menor que Período Final.");
        } else {
            history.push({
                pathname: 'relatorio-banco-de-horas',
                state: { data: { periodoInicial, periodoFinal } }
            });
        }
    }
    //Chamada dos modais dos relatórios
    const callFiltroEmissaoRelatorio = ({ path }) => {
        if (path.includes("realPlanejadoCusto")) {
            CustomModal.show({
                title: "Comparativo de Custo Planejado vs Real",
                body: <ModalFiltros
                    clientes={clientes}
                    projetos={dataProjects}
                    lideres={lideres}
                    habilitarTipoCusto={false}
                    habilitarMultiSelect={false}
                    habilitarDataMeses={true}
                    habilitarRadioTotalOuData={true}
                    buttonHandle={"comparativoDeCustoPlanejado"}
                    handleDados={handleDadosComparativoCustoPlanejamento}
                />
            })
        }
        if (path.includes("historicoCustoClienteProjeto")) {
            CustomModal.show({
                title: "Histórico custo de cliente / projeto",
                body: <ModalFiltros
                    clientes={clientes}
                    projetos={dataProjects}
                    lideres={lideres}
                    habilitarTipoCusto={true}
                    habilitarMultiSelect={true}
                    habilitarDataMeses={true}
                    buttonHandle={"historicoCustoDeCliente"}
                    handleDados={handleDadosHistoricoCustoClinte}
                />
            })
        }
        if (path.includes("relatorioCapacidade")) {
            CustomModal.show({
                title: "Relatório Capacidade da Área",
                body: <FiltroRelatorioCapacidade handleDadosRelatorioCapacidade={handleDadosRelatorioCapacidade} />
            })
        }
        if (path.includes("realPlanejadoFaturamento")) {
            CustomModal.show({
                title: "Comparativo de Faturamento Planejado vs Real",
                body: <ModalFiltros
                    clientes={clientes}
                    projetos={dataProjects}
                    lideres={lideres}
                    habilitarTipoCusto={false}
                    habilitarMultiSelect={false}
                    habilitarDataMeses={true}
                    habilitarRadioTotalOuData={true}
                    buttonHandle={"comparativoDeFaturamento"}
                    handleDados={handleDadosComparativoFaturamento}
                />
            })
        }
        if (path.includes("resultadoAnualProjeto")) {
            CustomModal.show({
                title: "Gerar Relatório do Resultado do Projeto",
                body: <ModalFiltros
                    clientes={clientes}
                    projetos={dataProjects}
                    lideres={lideres}
                    habilitarTipoCusto={false}
                    habilitarMultiSelect={false}
                    habilitarDataMeses={true}
                    habilitarRadioTotalOuData={true}
                    buttonHandle={"resultadoDoProjeto"}
                    handleDados={handleDadosResultadoProjeto}
                />
            })
        }
        if (path.includes("capacidadeProjeto")) {
            CustomModal.show({
                title: "Gerar Relatório de Capacidade por Projeto",
                body: <ModalFiltros
                    clientes={clientes}
                    projetos={dataProjects.filter(p => !p.name.includes("INT-1000"))}
                    lideres={lideres}
                    habilitarTipoCusto={false}
                    habilitarMultiSelect={true}
                    habilitarDataMeses={true}
                    buttonHandle={"capacidadePorProjeto"}
                    handleDados={handleDadosCapacidadePorProjeto}
                />
            })
        }
        if (path.includes("fluxoDeCaixaDeProjetos")) {
            CustomModal.show({
                title: "Gerar Relatório",
                body: <FiltroFluxoDeCaixa clientes={clientes} projetos={dataProjects} lideres={lideres} handleDadosProjetos={handleDadosFluxoCaixa} />
            })
        }
        if (path.includes("resultadosDoCliente")) {
            CustomModal.show({
                title: "Gerar Relatório de Resultados de Cliente/Líder",
                body: <FiltroResultadosDoCliente
                    clientes={clientes}
                    projetos={dataProjects}
                    lideres={lideres}
                    habilitarTipoCusto={false}
                    habilitarMultiSelect={false}
                    habilitarDataMeses={true}
                    habilitarRadioTotalOuData={true}
                    buttonHandle={"resultadosDoCliente"}
                    handleDados={handleDadosResultadosDoCliente}
                />
            })
        }
        if (path.includes("relatorioTurnover")) {
            CustomModal.show({
                title: "Gerar Relatório de Turnover",
                body: <FiltroRelatorioCapacidade handleDadosRelatorioCapacidade={handleDadosRelatorioTurnover} />
            })
        }
        if (path.includes("relatorioHistoricoCapacidade")) {
            CustomModal.show({
                title: "Gerar Relatório Histórico de Capacidade",
                body: <FiltroRelatorioCapacidade handleDadosRelatorioCapacidade={handleDadosRelatorioHistoricoCapacidade} />
            })
        }
        if (path.includes("comparativoPontoJira")) {
            CustomModal.show({
                title: "Gerar Relatório de Ponto vs Jira",
                body: <FiltroRelatorioCapacidade date={true} handleDadosRelatorioCapacidade={handleDadosRelatorioPontoJira} />
            })
        }
        if (path.includes("relatorioHorasExtras")) {
            CustomModal.show({
                title: "Gerar Relatório de Horas Extras",
                body: <FiltroRelatorioCapacidade date={true} handleDadosRelatorioCapacidade={handleDadosRelatorioHorasExtras} />
            })
        }
        if (path.includes("relatorioRelacaoHoras")) {
            CustomModal.show({
                title: "Gerar Relatório de Relação de Horas",
                body: <FiltroRelatorioCapacidade date={true} handleDadosRelatorioCapacidade={handleDadosRelatorioRelacaoHoras} />
            })
        }
        if (path.includes("relatorioHistoricoHorasExtras")) {
            CustomModal.show({
                title: "Gerar Relatório Histórico de Horas Extras",
                body: <FiltroRelatorioCapacidade handleDadosRelatorioCapacidade={handleDadosRelatorioHistoricoHorasExtras} />
            })
        }
        if (path.includes("relatorioBancoDeHoras")) {
            CustomModal.show({
                title: "Gerar Relatório Banco de Horas",
                body: <FiltroRelatorioCapacidade handleDadosRelatorioCapacidade={handleDadosRelatorioBancoDeHoras} />
            })
        }
    }

    //Effects
    useEffect(handleFiltro, [filtro]);

    useEffect(() => {
        getProjectsData()
        getClientsList()
    }, []);

    const handleMouseEnter = (iKey) => {
        setActivePopup(iKey);
    };

    const handleMouseLeave = () => {
        setActivePopup(null);
    };

    return (
        <PageContainer title="Relatórios Delivery" infoButton={< RelatorioListHelpModal />}>
            {dataProjects.length == 0 ? < Loading message={"Carregando..."}/> :  <>
            <header className="relatorios-main">
                <div className="d-flex justify-content-between align-items-center w-100">
                    <InputGroup className="flex-grow-1 mr-3" style={{maxWidth: "50%"}}>
                        <FormControl
                            className="filter-input"
                            value={filtro}
                            onChange={e => setFiltro(e.target.value)}
                            placeholder="Buscar relatório"
                            aria-label="Buscar relatório"
                            aria-describedby="busca-relatorio"
                            type="text"
                            autoComplete="off"
                        />
                        {filtro.length > 0 && (
                            <InputGroup.Text
                                id="busca-relatorio"
                                onClick={clearFiltro}
                                title="Limpar busca"
                            >
                                <MdClose/>
                            </InputGroup.Text>
                        )}
                    </InputGroup>
                    </div>
                </header>

                {filtrado.length == 0 && (
                    <div className="nenhum-relatorio">
                        <NothingToShow message={<>
                            <FaRegFrownOpen size={30} /> {`Nenhum relatório com o termo "${filtro}"`}
                        </>} />
                    </div>
                )}

                {filtrado.map((group, i) => {
                    const { groupLabel, groupKey, menus } = group;
                    const gKey = `${i}-${groupKey}`;

                    return (
                        <section key={gKey} className="relatorios-main">
                            <h4>{groupLabel}</h4>
                            <hr />
                            <Nav className="nav-container">
                                {menus.map((item, j) => {
                                    const { label, path, info } = item;
                                    const iKey = `${gKey}-${j}-${path.replace(" ", "")}`;

                                    return (
                                        <Nav.Item
                                            className="col-md-16 col-lg-6 hover-info"
                                            key={iKey}
                                            onClick={() => callFiltroEmissaoRelatorio({ label, path })}

                                        >
                                            <FaFileAlt size={20} />
                                            <Nav.Link>
                                                {label}
                                                <span
                                                    onMouseEnter={() => handleMouseEnter(iKey)}
                                                    onMouseLeave={handleMouseLeave}
                                                    className='ml-1 text-secondary'
                                                >
                                                    <FiInfo />
                                                </span>
                                            </Nav.Link>

                                            {activePopup === iKey && (
                                                <div className={`hover-popup${j >= menus.length - 2 ? ' hover-popup-top' : ''}`}>
                                                    {`${info}`}
                                                </div>
                                            )}
                                        </Nav.Item>
                                    );
                                })}
                            </Nav>
                        </section>
                    );
                })}

                <CustomModal />
            </>}
        </PageContainer>
    )
}

export default RelatoriosMainPage;

